import {
  CloseOutlined,
  DownOutlined,
  FilterOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Checkbox,
  Collapse,
  Dropdown,
  Flex,
  Input,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import favoIcon from "../../assets/Icons/favoIcon.svg";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import recentIcon from "../../assets/Icons/recentIcon.svg";
import starIcon from "../../assets/Icons/star.svg";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setQuery, clearQuery } from "../../store/filters";
import "./ActionHeader.scss";
import "./FilterPanel.scss";

const { Panel } = Collapse;

/* Long filter names are ellipsised by CSS; this adds the full text back as a
   tooltip, but only when the label is actually cut off. Measured on hover so
   nothing is computed for labels nobody looks at. */
const TruncatedText = ({ text, className = "" }) => {
  const ref = useRef(null);
  const [isClipped, setIsClipped] = useState(false);

  const measure = () => {
    const el = ref.current;
    if (el) setIsClipped(el.scrollWidth > el.clientWidth + 1);
  };

  return (
    <Tooltip title={isClipped ? text : ""} mouseEnterDelay={0.35}>
      <span
        ref={ref}
        className={`ce-truncate ${className}`.trim()}
        onMouseEnter={measure}
      >
        {text}
      </span>
    </Tooltip>
  );
};

const DEFAULT_MONTHS = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
];

const FilterDropdown = ({
  setPrimaryItems,
  setSecondaryItems,
  secondaryItems,
  primaryItems,
  fetchData,
  fetchData2,
  fetchData3,
  variant = "1",
  updateApis = () => {},
}) => {
  const [open, setOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedCategory, setSelectedCategory] = useState("portfolios");
  const [categorySelections, setCategorySelections] = useState({});
  const [readyToApply, setReadyToApply] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { portfolios } = useSelector((state) => state.portfolio);
  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { filter_list, query, analyse_filters } = useSelector(
    (state) => state?.filters,
  );
  const filterSource = variant === "1" ? analyse_filters : filter_list;

  const variant1Categories = [
    { title: "Recently Selected", value: "recently" },
    { title: "Favourites", value: "favourites" },
    { title: "Month Wise", value: "months" },
    { title: "State Wise", value: "state" },
    { title: "Region Wise", value: "region" },
    { title: "Status", value: "status" },
    { title: "Action Code", value: "action_code" },
    { title: "Team Member", value: "team_member" },
    { title: "Team Leader", value: "team_leader" },
    { title: "Loan Type", value: "loan_type" },
    { title: "Agency", value: "agency" },
  ];

  const variant2Categories = [
    { title: "Recently Selected", value: "recently" },
    { title: "Favourites", value: "favourites" },
    { title: "Month Wise", value: "months" },
    { title: "Disposition", value: "disposition" },
    { title: "State Wise", value: "states" },
    { title: "Portfolio Wise", value: "portfolios" },
    { title: "Region Wise", value: "region" },
  ];

  const categories = variant === "2" ? variant2Categories : variant1Categories;

  useEffect(() => {
    if (query) {
      setCategorySelections(query);
    }
  }, [query]);

  const objectCategories = [
    "portfolios",
    "supervisors",
    "teamleads",
    "telecallers",
    "field_agents",
    "team_member",
    "months",
    // "disposition",
  ];

 const toggleTrust = (trust) => {
  const prevSelected = categorySelections[selectedCategory] || [];
  let valueToStore;

  if (selectedCategory === "disposition") {
    valueToStore = trust?.key;
  } else if (objectCategories.includes(selectedCategory)) {
    valueToStore = trust?.id !== undefined ? trust.id : trust;
  } else {
    valueToStore = trust;
  }

  const isSelected = prevSelected.some(
    (t) => t === valueToStore || String(t) === String(valueToStore),
  );
  const updatedTrusts = isSelected
    ? prevSelected.filter(
        (t) => t !== valueToStore && String(t) !== String(valueToStore),
      )
    : [...prevSelected, valueToStore];

  setCategorySelections({
    ...categorySelections,
    [selectedCategory]: updatedTrusts,
  });
};



  const handleSelectAll = () => {
    // Only what the current search actually shows.
    const visible =
      filteredCategories.find((c) => c.value === selectedCategory)
        ?.filteredFilters || [];

    let values;
    if (selectedCategory === "disposition") {
      values = visible.map((f) => f.key);
    } else if (objectCategories.includes(selectedCategory)) {
      values = visible.map((f) => (f?.id !== undefined ? f.id : f));
    } else {
      values = visible.map((f) => f.name || f);
    }

    const existing = categorySelections[selectedCategory] || [];
    setCategorySelections({
      ...categorySelections,
      [selectedCategory]: Array.from(new Set([...existing, ...values])),
    });
  };



  const clearAll = () => {
    setCategorySelections({});
    dispatch(clearQuery());
    // setSecondaryItems([]);
  };

  const applyFilters = () => {
    setOpen(false);
    setReadyToApply(true);
    dispatch(setQuery(categorySelections));
    updateApis(categorySelections);
    if (typeof fetchData === "function") {
      dispatch(fetchData(categorySelections)).then(() =>
        setReadyToApply(false),
      );
    }
    if (typeof fetchData2 === "function") {
      dispatch(fetchData2(categorySelections));
    }
    if (typeof fetchData3 === "function") {
      dispatch(fetchData3(categorySelections));
    }
  };

  console.log(categorySelections, "categorySelections");

  const toggleFavorite = (trust) => {
    // Implement favorite logic if needed
  };

  const handleSelectCategory = (cat) => {
    console.log(cat, "kldjfkdjf");
    setSelectedCategory(cat?.value);
    // if (cat.title !== "Favourites" && cat.title !== "Recently Selected") {
    //   setPrimaryItems([cat?.title]);
    // }
  };

  /* Filter items are plain strings for some categories (state, region,
     status) and objects for others (portfolios, telecallers, disposition).
     Always read the displayed label through this. */
  const getFilterLabel = (item) => {
    if (item == null) return "";
    if (typeof item === "string") return item;
    return String(item.name ?? item.key ?? item.email ?? item.id ?? "");
  };

  const filteredCategories = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    const withFilters = categories.map((cat) => {
      let baseFilters = [];
      if (cat.value === "months") {
        const backendMonths = filterSource?.find((f) => f.name === cat.value)?.filters;
        baseFilters =
          Array.isArray(backendMonths) && backendMonths.length > 0
            ? backendMonths
            : DEFAULT_MONTHS;
      } else {
        baseFilters = filterSource?.find((f) => f.name === cat.value)?.filters || [];
      }
      return {
      ...cat,
      filteredFilters: baseFilters.filter(
        (item) => !term || getFilterLabel(item).toLowerCase().includes(term),
      ),
    }});

    // While searching, hide categories that have nothing to show.
    return term
      ? withFilters.filter((cat) => cat.filteredFilters.length > 0)
      : withFilters;
  }, [categories, filterSource, searchTerm]);

  /* Keep the rail selection valid: if a search hides the active category,
     fall through to the first one that still has matches. */
  useEffect(() => {
    if (!filteredCategories.length) return;
    const stillVisible = filteredCategories.some(
      (c) => c.value === selectedCategory,
    );
    if (!stillVisible) {
      setSelectedCategory(filteredCategories[0].value);
    }
  }, [filteredCategories, selectedCategory]);

  /* trust_id is the Portfolio selector that sits on the page beside this
     button, with its own chips. This panel neither lists it as a category nor
     draws its chips on the analysis screens (see selectedChips below), yet it
     seeds its state from the whole query - so those selections were counted
     here as well: the trigger read "Filters 3" for three portfolios picked
     elsewhere, and the panel read "Selected 3" over an empty chip list. */
  const countsPortfolio = !pathname.startsWith("/analysis/");
  const uncountedKeys = countsPortfolio ? [] : ["trust_id"];

  /* Count only list-style selections; scalar query keys (intensity, flags)
     are set by other screens and are not editable from this panel. */
  const countSelections = (source) =>
    Object.entries(source || {}).reduce(
      (n, [key, v]) =>
        n + (uncountedKeys.includes(key) || !Array.isArray(v) ? 0 : v.length),
      0,
    );

  const selectedCount = useMemo(
    () => countSelections(categorySelections),
    [categorySelections, pathname],
  );

  const appliedCount = useMemo(() => countSelections(query), [query, pathname]);

  const activeCategoryCount = useMemo(
    () =>
      Object.entries(categorySelections || {}).filter(
        ([key, v]) =>
          !uncountedKeys.includes(key) && Array.isArray(v) && v.length > 0,
      ).length,
    [categorySelections, pathname],
  );

  const activeCategory = filteredCategories.find(
    (c) => c.value === selectedCategory,
  );
  const activeFilters = activeCategory?.filteredFilters || [];

  const isTrustChecked = (trust) => {
    const current = categorySelections[selectedCategory] || [];
    if (selectedCategory === "disposition") return current.includes(trust.key);
    if (objectCategories.includes(selectedCategory)) {
      const id = trust?.id !== undefined ? trust.id : trust;
      return current.some((t) => t === id || String(t) === String(id));
    }
    return current.includes(trust);
  };

  const selectedChips = Object.entries(categorySelections).flatMap(
    ([cat, selected]) => {
      if (!Array.isArray(selected)) return [];
      return selected
        .map((trustId) => {
          if (cat === "trust_id" && pathname.startsWith("/analysis/")) {
            return null;
          }
          let displayName = trustId;
          if (objectCategories.includes(cat)) {
            const filterObj = filterSource
              ?.find((f) => f.name === cat)
              ?.filters?.find((f) => f?.id === trustId || String(f?.id) === String(trustId));
            displayName =
              filterObj?.name ||
              (cat === "months"
                ? DEFAULT_MONTHS.find((m) => m.id === trustId || String(m.id) === String(trustId))?.name
                : null) ||
              filterObj?.key ||
              filterObj?.email ||
              trustId;
          }
          return { cat, trustId, displayName };
        })
        .filter(Boolean);
    },
  );

  const removeChip = (cat, trustId) => {
    const updated = (categorySelections[cat] || []).filter(
      (t) => t !== trustId && String(t) !== String(trustId),
    );
    setCategorySelections({ ...categorySelections, [cat]: updated });
  };

  const dropdownContent = (
    <div className="ce-filter">
      <div className="ce-filter__head">
        <div className="ce-filter__title">
          <span className="ce-filter__icon">
            <FilterOutlined />
          </span>
          <div>
            <h2>Filters</h2>
            <p>
              {selectedCount > 0
                ? `${selectedCount} selected across ${activeCategoryCount} ${
                    activeCategoryCount === 1 ? "category" : "categories"
                  }`
                : "Narrow the data down to what you need"}
            </p>
          </div>
        </div>
        {/* Actions live in the head so they are reachable without
            scrolling past the options. */}
        <div className="ce-filter__head-actions">
          <button type="button" className="ce-filter__ghost" onClick={clearAll}>
            Clear all
          </button>
          <button
            type="button"
            className="ce-filter__apply"
            onClick={applyFilters}
          >
            Apply filters
          </button>
          <button
            type="button"
            className="ce-filter__close"
            aria-label="Close filters"
            onClick={() => setOpen(false)}
          >
            <CloseOutlined />
          </button>
        </div>
      </div>

      <div className="ce-filter__search">
        <Input
          prefix={<img src={searchIcon} alt="" />}
          placeholder="Search across every filter"
          allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="ce-filter__body">
        <div className="ce-filter__col ce-filter__col--cats">
          <div className="ce-filter__col-head">Category</div>
          <div className="ce-filter__cats">
            {filteredCategories.length === 0 && (
              <div className="ce-filter__empty">
                <InboxOutlined />
                <span>No category matches "{searchTerm}"</span>
              </div>
            )}
            {filteredCategories?.map((cat, index) => {
              const count = (categorySelections[cat?.value] || []).length;
              return (
                <React.Fragment key={index}>
                  <button
                    type="button"
                    className={`ce-filter__cat ${
                      selectedCategory === cat?.value ? "is-active" : ""
                    }`}
                    onClick={() => handleSelectCategory(cat)}
                  >
                    {cat.title === "Recently Selected" ? (
                      <img src={recentIcon} alt="" />
                    ) : cat.title === "Favourites" ? (
                      <img src={favoIcon} alt="" />
                    ) : null}
                    <TruncatedText text={cat?.title} />
                    {count > 0 && (
                      <i className="ce-filter__cat-count">{count}</i>
                    )}
                  </button>
                  {cat.title === "Favourites" && (
                    <div className="ce-filter__divider" />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <div className="ce-filter__col ce-filter__col--opts">
          <div className="ce-filter__col-head">
            <TruncatedText text={activeCategory?.title || "Options"} />
            {activeFilters.length > 0 && (
              <button
                type="button"
                className="ce-filter__link"
                onClick={handleSelectAll}
              >
                Select all
              </button>
            )}
          </div>
          <div className="ce-filter__opts">
            {activeFilters.length > 0 ? (
              activeFilters.map((trust) => (
                <div
                  key={trust?.id ?? trust?.key ?? getFilterLabel(trust)}
                  className="ce-filter__opt"
                >
                  <Checkbox
                    checked={isTrustChecked(trust)}
                    onChange={() => toggleTrust(trust)}
                  >
                    <TruncatedText text={getFilterLabel(trust)} />
                  </Checkbox>
                  <span
                    className="ce-filter__star"
                    onClick={() => toggleFavorite(trust)}
                  >
                    <img src={starIcon} alt="favourite" />
                  </span>
                </div>
              ))
            ) : (
              <div className="ce-filter__empty">
                <InboxOutlined />
                <span>
                  {searchTerm
                    ? "No filters match your search"
                    : "Pick a category to see its options"}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="ce-filter__col ce-filter__col--sel">
          <div className="ce-filter__col-head">
            <span>Selected</span>
            {selectedCount > 0 && (
              <span className="ce-filter__count">{selectedCount}</span>
            )}
          </div>
          <div className="ce-filter__chips">
            {selectedChips.length > 0 ? (
              selectedChips.map(({ cat, trustId, displayName }) => (
                <Tag
                  key={cat + trustId}
                  closable
                  onClose={() => removeChip(cat, trustId)}
                  closeIcon={<CloseOutlined />}
                >
                  <TruncatedText text={displayName} />
                </Tag>
              ))
            ) : (
              <div className="ce-filter__empty">
                <InboxOutlined />
                <span>Nothing selected yet</span>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );

  const mobileMenuDropdownContent = (
    <div className="ce-filter ce-filter--mobile">
      <div className="ce-filter__head">
        <div className="ce-filter__title">
          <span className="ce-filter__icon">
            <FilterOutlined />
          </span>
          <div>
            <h2>Filters</h2>
            <p>
              {selectedCount > 0
                ? `${selectedCount} selected`
                : "Narrow the data down"}
            </p>
          </div>
        </div>
        <div className="ce-filter__head-actions">
          <button type="button" className="ce-filter__ghost" onClick={clearAll}>
            Clear all
          </button>
          <button
            type="button"
            className="ce-filter__apply"
            onClick={applyFilters}
          >
            Apply
          </button>
          <button
            type="button"
            className="ce-filter__close"
            aria-label="Close filters"
            onClick={() => setOpen(false)}
          >
            <CloseOutlined />
          </button>
        </div>
      </div>

      <div className="ce-filter__body">
        <Collapse defaultActiveKey={["1"]} bordered={false}>
          {filteredCategories?.map((cat, index) => {
            const currentFilter = cat.filteredFilters;
            const currentSelections = categorySelections[cat.value] || [];
            return (
              <Panel
                header={
                  <Flex gap={2}>
                    <Badge count={currentSelections?.length} offset={[10, 1]}>
                      <h2>{cat?.title}</h2>
                    </Badge>
                  </Flex>
                }
                key={index + 1}
                className="filter-panel"
              >
                <div className="ce-filter__col-head">
                  <span>Options</span>
                  {currentFilter.length > 0 && (
                    <button
                      type="button"
                      className="ce-filter__link"
                      onClick={() => {
                        const values = objectCategories.includes(cat.value)
                          ? currentFilter.map((f) => (f?.id !== undefined ? f.id : f))
                          : currentFilter.map((f) => f.name || f);
                        setCategorySelections({
                          ...categorySelections,
                          [cat.value]: values,
                        });
                      }}
                    >
                      Select all
                    </button>
                  )}
                </div>
                <div className="ce-filter__opts">
                  {currentFilter.length > 0 ? (
                    currentFilter.map((trust) => {
                      const trustId = objectCategories.includes(cat.value)
                        ? (trust?.id !== undefined ? trust.id : trust)
                        : trust;
                      const isChecked = currentSelections.some(
                        (t) => t === trustId || String(t) === String(trustId),
                      );
                      return (
                        <div
                          key={trust?.id ?? trust?.key ?? getFilterLabel(trust)}
                          className="ce-filter__opt"
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={() => {
                              const updated = isChecked
                                ? currentSelections.filter(
                                    (t) => t !== trustId && String(t) !== String(trustId),
                                  )
                                : [...currentSelections, trustId];
                              setCategorySelections({
                                ...categorySelections,
                                [cat.value]: updated,
                              });
                            }}
                          >
                            <TruncatedText text={getFilterLabel(trust)} />
                          </Checkbox>
                          <span
                            className="ce-filter__star"
                            onClick={() => toggleFavorite(trust)}
                          >
                            <img src={starIcon} alt="favourite" />
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="ce-filter__empty">
                      <InboxOutlined />
                      <span>No options in this category</span>
                    </div>
                  )}
                </div>
              </Panel>
            );
          })}
        </Collapse>
      </div>

    </div>
  );

  /* Not memoised on purpose: the panel also reacts to selectedCategory, which
     the old dependency list omitted — that returned a stale element and left
     the panel frozen when you switched category. Both elements are built on
     every render anyway, so there was nothing to save. */
  const isDropdown =
    screenWidth > 800 ? dropdownContent : mobileMenuDropdownContent;

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => isDropdown}
      placement="bottomRight"
      trigger={["click"]}
    >
      <button
        type="button"
        className={[
          "ce-filter-trigger",
          appliedCount > 0 ? "is-active" : "",
          open ? "is-open" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        aria-label="Open filters"
      >
        {/* An icon only - this button draws its own border, label and caret.
            FilterVariant2.svg is a whole 91x44 button graphic (border plus a
            baked-in "Filter" label), so using it here nested a second button
            inside this one. It is still correct in AllocationFilter, which
            renders it as the trigger itself. */}
        <FilterOutlined />
        <span>Filters</span>
        {appliedCount > 0 && (
          <i className="ce-filter-trigger__badge">{appliedCount}</i>
        )}
        <DownOutlined className="ce-caret" />
      </button>
    </Dropdown>
  );
};

export default FilterDropdown;
